module.exports = __webpack_public_path__ + "static/media/book.6fe185f1.svg";